import { type FC } from 'react';

import { CarouselMainContainer } from 'shared/components/Carousel';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Promos } from 'shared/containers/Promos';
import { MortgageCalculatorContainer } from 'shared/packages/mortgage-calculator';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AboutContainer } from '../About';
import { AwardsContainer } from '../Awards';
import { ContentWrapper } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { HeaderContainer } from '../Header';
import { PikHistoryContainer } from '../PikHistory';
import { PikInNumbersContainer } from '../PikInNumbers';
import { PikInNumbersV2Container } from '../PikInNumbersV2';
import { PikProjectsContainer } from '../PikProjects';
import { RatingsContainer } from '../Ratings';
import { SeriaPlusContainer } from '../SeriaPlus';
import { SeriaPlusV2Container } from '../SeriaPlusV2';
import { EnvironmentForLifeAndBusinessContainer, ProductFeaturesOfTheQuarters } from '../SliderBlockTypeOne';
import { SmartHomeContainer } from '../SmartHome';

export const ApplicationContent: FC = () => {
  const { config } = useApplicationContext();

  const isDesignV2Enabled = !!config.get<boolean>('Martech.PikLanding.DesignV2.Enabled');

  return (
    <div data-testid="ApplicationContent">
      <CarouselMainContainer />
      <ContentWrapper>
        <HeaderContainer />
        <FactsContainer />
        <Promos />
        <PikProjectsContainer />
        {isDesignV2Enabled ? <SeriaPlusV2Container /> : <SeriaPlusContainer />}
        <MortgageCalculatorContainer />
        {isDesignV2Enabled ? <PikInNumbersV2Container /> : <PikInNumbersContainer />}
        <EnvironmentForLifeAndBusinessContainer isDesignV2Enabled={isDesignV2Enabled} />
        <ProductFeaturesOfTheQuarters />
        {isDesignV2Enabled ? <SmartHomeContainer /> : null}
        <PikHistoryContainer />
        <RatingsContainer />
        <AwardsContainer />
        <AboutContainer />
        <AdfoxPixelContainer />
      </ContentWrapper>
    </div>
  );
};
